import { Box, PageError } from '@moonpig/launchpad-components'
import { theme } from '@moonpig/launchpad-theme'
import { ThemeProvider } from '@moonpig/launchpad-utils'

import Head from 'next/head'
import React from 'react'
import { Page } from '../../types'
import { useLocaleText } from './Error500Page.locale'

const Error500Page: Page = () => {
  const t = useLocaleText()
  const title = `${t('heading')} (500)`

  return (
    <ThemeProvider theme={theme}>
      <Head>
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="robots" content="noindex" />
      </Head>
      <Box my={{ xs: 10, lg: 13 }}>
        <PageError title={t('heading')}>
          <p>{t('message')}</p>
        </PageError>
      </Box>
    </ThemeProvider>
  )
}

Error500Page.layout = 'none'

export { Error500Page }
